export async function dynamicLoadUpgradeApiClient() {
  return (await import('./upgrade.api-client')).UpgradeApiClient;
}
export async function dynamicLoadUpgradeQueries(httpClient) {
  return (await import('./upgrade.api-client')).UpgradeApiClient.queries({
    httpClient
  });
}
//# sourceMappingURL=utils.js.map